import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { apiSearch, apiFetch, apiRemove } from "../modules/utility";

const apiBase = "user";
const item = "user";
const idsField = "userIds";
const onSuccessRedirectTo = `/users`;

const search = (p = {}) => {
  const { includeHidden, callback = _.noop } = p;
  return (dispatch) => {
    apiSearch({
      base: apiBase,
      params: {
        includeHidden,
      },
      dispatch,
      callback,
    });
  };
};

const get = ({ params = {}, callback = _.noop }) => {
  return (dispatch) => {
    apiFetch({
      method: `${apiBase}.get`,
      params,
      dispatch,
      callback,
    });
  };
};

const add = ({ params, callback = _.noop }) => {
  return (dispatch) => {
    apiFetch({
      method: `${apiBase}.add`,
      listNameToUpdate: idsField,
      params,
      dispatch,
      successMessage: `New ${item} was created successfully. 
				Click continue to return to the ${item}s page.`,
      onSuccessRedirectTo,
      callback,
    });
  };
};

const remove = ({ userId, callback = _.noop }) => {
  return (dispatch) => {
    apiRemove({
      base: apiBase,
      dispatch,
      id: userId,
      callback,
    });
  };
};

const update = ({ params, callback = _.noop }) => {
  return (dispatch) => {
    apiFetch({
      method: `${apiBase}.update`,
      params,
      dispatch,
      successMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
      onSuccessRedirectTo,
      callback,
    });
  };
};

const mapStateToProps = (state, ownProps) => {
  //- Get a single user and the list of users
  const userId = ownProps.userId
    ? ownProps.userId
    : _.get(ownProps, ["match", "params", "userId"]);
  const user = _.get(state.maps, ["user", userId]);

  let users = [];
  if (state.lists.userIds) {
    users = _.map(state.lists.userIds, (id) => state.maps.user[id]);
  }

  return {
    user,
    users,
    geoTabGroupMap: state.maps.geoTabGroup || {},
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUser: get,
      addUser: add,
      updateUser: update,
      removeUser: remove,
      searchUsers: search,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps);
